<template>
  <div pageB>
    <article>
      <div class="cover">
        <div class="cont">
          <h1></h1>
          <p class="reward"></p>
          <div class="form">
            <ul class="os">
              <li><label class="radio"><input type="radio" name="os" value="ad" v-model="info.os"><i></i>Android</label></li>
              <li><label class="radio"><input type="radio" name="os" value="ios" v-model="info.os"><i></i>iOS</label></li>
            </ul>
            <p class="phone">
              <input v-model="info.phone" type='number' maxlength="11" placeholder='휴대폰 번호를 " – " 없이 입력하세요'/>
            </p>
            <a class="btn-join" @click="request"></a>
            <ul class="clause">
              <li><label class="checkbox"><input type="checkbox" value="a" v-model="info.agree"><i></i><span>1. 개인정보 수집 및 이용 동의 (필수)</span></label><a @click="clauseOn"></a></li>
              <li><label class="checkbox"><input type="checkbox" value="b" v-model="info.agree"><i></i><span>2. 개인정보 처리 위탁 동의 (필수)</span></label><a @click="clauseOn"></a></li>
              <li><label class="checkbox"><input type="checkbox" value="c" v-model="info.cAgree"><i></i><span>3. 게임빌 게임 출시 및 업데이트, 각종 <br class="m-ent"/>이벤트 광고 알림 수신 동의 (선택)</span></label><a @click="clauseOn"></a></li>
            </ul>
            <p class="suggest"></p>
          </div>
          <p class="term">
            <a class="btn-go" @click="goGoogle"></a>
            <a class="sns-go" @click="goFB"></a>
          </p>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import oax from '../utils/oax';

export default {
  name: 'pageB',
  data() {
    return {
      info: {
        os: 'ad',
        agree: [],
        cAgree: false,
        phone: null,
        r: '100',
      },
    };
  },
  methods: {
    clauseOn() {
      this.$store.commit('onClause');
    },
    request() {
      let msg = null;
      if (this.info.agree.length < 2) { msg = '정보이용 동의가 필요합니다. <br/> 개인 정보 수집 및 SMS 수신 동의 체크해주세요.'; }
      if (!this.info.phone || this.info.phone.length < 11) { msg = '휴대폰 번호를 정확하게 입력해주세요.'; }
      if (msg) {
        this.$store.commit('onMsg', msg);
        return;
      }

      oax.post('/api/', {
        phone: this.info.phone, os: this.info.os, agree: this.info.cAgree ? 'true' : 'false', r: this.info.r,
      })
        .then((data) => {
          if (data.data.retCode === 100) {
            console.log(window.md5(this.info.phone));
            window.fbq('track', 'CompleteRegistration');
            window.gtag('event', 'click', { event_category: 'Registration' });
            window.adpick_webtracking({ site: 'gamevil', event: 'registered', match_key: window.md5(this.info.phone) });
            this.$store.commit('onComplete');
          } else {
            this.$store.commit('onMsg', data.data.retMsg);
          }
        });
    },
    checkR() {
      let rv = window.location.search.match(/[?&]r=(\d+)/);
      if (!rv) return '100';

      rv = rv[1];
      if (this.getType(Number(rv)) === 'Number') {
        const v = Number(rv);
        if (v > 0 && v < 100) return v;
        return '100';
      }
      return rv;
    },

    getType(target) {
      return Object.prototype.toString.call(target).slice(8, -1);
    },

    goGoogle() {
      window.open('https://play.google.com/store/apps/details?id=com.gamevil.talion.android.google.global.normal');
      window.gtag('event', 'click', { event_category: 'Googlelink' });
    },

    goFB() {
      window.gtag('event', 'click', { event_category: 'Facebooklink' });
      window.open('https://www.facebook.com/TalionKR');
    },
  },

  mounted() {
    this.info.r = this.checkR();
  },
};
</script>

<style lang="less">
  @import "../less/proj";
  .mob{
    [pageB]{.cover("@{mob}/p2/bg.jpg"); .bg-x(50%); .-box;
      article{
        .cover{ .pt(150);  .pb(180px);
          .cont{
            >*{.mh-c;}
            h1{.contain("@{mob}/p2/title.png"); .wh(685,335);}
            .reward{.contain("@{mob}/p2/reward.png"); .wh(717,693); .mb(60);}
            .form{ .tc; .mb(70);
              .os{ .mb(36);
                li{.ib; .p(0,18);}
              }
              .phone{ .wh(100%,70px); .tc;
                input{background: #3d1814;  .-a(#af272b); .wh(600,100%); .tc; color:#ffd2a6; .fs(30); outline: none;
                  &::placeholder{.fs(30); color:#ffd2a6;}
                }
              }
              .btn-join{.contain("@{mob}/p2/btn-join.png"); .wh(600,149); .block; .mh-c; .mb(12);}
              .clause{.tl; .w(604); .mh-c;
                li{.p(18,0); .rel;
                  &:last-of-type{label{color:#91eaff;}}
                  a{.block; .abs; .wh(112,23); .contain("@{mob}/p2/btn-detail.png"); .t(20); .r(0); }
                }
              }
              .suggest{.contain("@{mob}/p2/clause.png"); .wh(599,161); .mt(40); .mh-c;}
            }
            .term{.contain("@{mob}/p2/footer.png"); .wh(600,1305); .rel;
              .btn-go{.block; .abs; .wh(315,100); .l(150); .t(330);}
              .sns-go{.block; .abs; .wh(315,65); .l(140); .t(725);}
            }
          }
        }
      }
    }
  }

  .pc{
    [pageB]{ .fix; .cover("@{pc}/p2/bg.jpg"); .bg-x(50%); .wh(100%); .min-h(100%); .-box; .min-w(1140px);
      article{ .w(100%); .abs; .t(85px); .b(78px);
        .cover{.wh(100%); .rel; overflow-y:auto; overflow-x:hidden; -webkit-overflow-scrolling: touch;
          .cont{.wh(100%,800px); .abs;
            >*{.mh-c;}
            h1{.contain("@{pc}/p2/title.png"); .wh(685px,282px); .mt(160px); .mb(10px);}
            .reward{.contain("@{pc}/p2/reward.png"); .wh(1104px,439px);}
            .term{.contain("@{pc}/p2/footer.png"); .wh(799px,544px); .pb(180px); .rel;
              &:before{.cnt; .abs; .wh(180px); .contain("@{pc}/p2/footerE.png"); .l(-50px); .t(-50px);}
              .btn-go{.block; .abs; .wh(180px,56px); .r(60px); .t(70px);}
              .sns-go{.block; .abs; .wh(224px,45px); .r(60px); .t(224px);}
            }
            .form{ .tc; .mb(70px);
              .os{ .mb(20px);
                li{.ib; .p(0,18px);}
              }
              .phone{ .wh(100%,70px); .tc;
                input{background: #3d1814;  .-a(#af272b); .wh(729px,100%); .tc; color:#ffd2a6; .fs(26px); outline: none;
                  &::placeholder{.fs(26px); color:#ffd2a6;}
                }
              }
              .btn-join{.contain("@{pc}/p2/btn-join.png"); .wh(556px,166px); .block; .mh-c;}
              .clause{.tl; .w(720px); .mh-c;
                li{.p(8px,0); .rel;
                  &:last-of-type{label{color:#91eaff;}}
                  a{.block; .abs; .wh(90px,18px); .contain("@{pc}/p2/btn-detail.png"); .t(10px); .r(0); }
                }
              }
              .suggest{.contain("@{pc}/p2/clause.png"); .wh(720px,104px); .mt(34px); .mh-c; .bg-s(607px,104px);}
            }
          }
        }
      }
      @media screen and (max-width: @screen-xxl-min){
        article{.t(63px); .b(56px);}
      }
     /* @media screen and (max-height: 1200px){
        article{
          .cover{
            .cont{transform:translateY(0); .t(140);}
          }
        }
      }*/
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/pageB.vue